export default "__VITE_ASSET__dbbadfb6__"